export function H1({ className = '', children, ...props }) {
  return <h1 className={['text-3xl font-bold text-neutral-900 dark:text-neutral-50', className].join(' ')} {...props}>{children}</h1>;
}

export function H2({ className = '', children, ...props }) {
  return <h2 className={['text-2xl font-semibold text-neutral-900 dark:text-neutral-50', className].join(' ')} {...props}>{children}</h2>;
}

export function H3({ className = '', children, ...props }) {
  return <h3 className={['text-xl font-semibold text-neutral-900 dark:text-neutral-50', className].join(' ')} {...props}>{children}</h3>;
}

export function H4({ className = '', children, ...props }) {
  return <h4 className={['text-lg font-medium text-neutral-900 dark:text-neutral-50', className].join(' ')} {...props}>{children}</h4>;
}

export function H5({ className = '', children, ...props }) {
  return <h5 className={['text-base font-medium text-neutral-900 dark:text-neutral-50', className].join(' ')} {...props}>{children}</h5>;
}

export function H6({ className = '', children, ...props }) {
  return <h6 className={['text-sm font-medium text-neutral-900 dark:text-neutral-50', className].join(' ')} {...props}>{children}</h6>;
}

export function Body({ className = '', children, ...props }) {
  return <p className={['text-sm text-neutral-700 dark:text-neutral-300', className].join(' ')} {...props}>{children}</p>;
}

export function Small({ className = '', children, ...props }) {
  return <p className={['text-xs text-neutral-600 dark:text-neutral-400', className].join(' ')} {...props}>{children}</p>;
}

export function Muted({ className = '', children, ...props }) {
  return <span className={['text-sm text-neutral-500 dark:text-neutral-500', className].join(' ')} {...props}>{children}</span>;
}

export function Code({ className = '', children, ...props }) {
  return <code className={['font-mono text-sm bg-neutral-100 dark:bg-neutral-800 text-neutral-800 dark:text-neutral-200 px-1 py-0.5 rounded', className].join(' ')} {...props}>{children}</code>;
}

export function Link({ className = '', children, ...props }) {
  return <a className={['text-primary-600 dark:text-primary-400 hover:underline', className].join(' ')} {...props}>{children}</a>;
}
